export const willBeVnmEligible = (context: MovingStateMachineContext) =>
  context.utility.vnmEligible;

const isCurrentlyVnmEligible = (context: MovingStateMachineContext) =>
  context.selectedUtilityAccount?.utility.vnmEligible;
const isUtilityConnected = (context: MovingStateMachineContext) =>
  !!context.selectedUtilityAccount?.connected;

export const isVnmToVnm = (context: MovingStateMachineContext) =>
  willBeVnmEligible(context) && isCurrentlyVnmEligible(context);
export const isNonVnmToVnmConnected = (context: MovingStateMachineContext) =>
  willBeVnmEligible(context) &&
  !isCurrentlyVnmEligible(context) &&
  isUtilityConnected(context);
export const isNonVnmToVnmUnconnected = (context: MovingStateMachineContext) =>
  willBeVnmEligible(context) &&
  !isCurrentlyVnmEligible(context) &&
  !isUtilityConnected(context);
export const isToNonVnmConnected = (context: MovingStateMachineContext) =>
  !willBeVnmEligible(context) && isUtilityConnected(context);
export const isToNonVnmUnconnected = (context: MovingStateMachineContext) =>
  !willBeVnmEligible(context) && !isUtilityConnected(context);
